import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { getApplicationIdAndProdCode } from "./utils";
import {
  getVersionedCallbackUrl,
  redirectToWebform,
  getSessionData,
} from "@repo/shared-utils/common-utils";
import { offerAPI } from "../../../api-client/src/services/icors.service";

export const emiHandler: SSORedirectHandler = async (data) => {
  const { custType, mobileNo } = await getSessionData();
  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, ["EMI"]);
  const product = "EMI";
  const resume = applicationID !== undefined;
  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  const [offer] = (await offerAPI("emi")) ?? [];
  let redirData: Record<string, unknown> = {};
  if (isOpenInApp()) {
    const urlParams = new URL(window.location.href);
    const redirDataParam = urlParams.searchParams.get("redirData");
    if (redirDataParam) {
      try {
        redirData = JSON.parse(redirDataParam);
      } catch {
        redirData = {};
      }
    }
    const appData = {
      applicationID: applicationID ?? "",
      offerId: offer?.id ?? "",
      offerAmount: offer?.icorsAmount ?? "",
      icorsOfferType: offer?.icorsOfferType ?? "",
      custType,
      prodCode: prodCode,
      product,
      loginTimestamp: data.data?.loginTimestamp,
      resume,
      consentProduct: "EMICARD",
      consentId: "TnC-EMICARD",
      consentCategory: "TnC",
      module: "EMI",
      mobileNumber: mobileNo,
      origin: "pdp_lite",
      tncversion: data.data?.instaEmi?.tncVersion,
      link: urlParams.href,
      ...redirData,
    };
    const appIdDetails = {
      appId: applicationID ?? "",
    };
    const inAppRedirectionPrompt = `inAppDeepLink://bajajsuperapp://dyninApp/EMI/1/[{"encryptionKey":"","payload":"${encodeURIComponent(
      JSON.stringify(appIdDetails)
    )}","module":"test","operation":"custRelationshipDetails"}]/${encodeURIComponent(JSON.stringify(appData))}`;
    window.tarsier?.invokePrompt(inAppRedirectionPrompt, true);
    return;
  }
  redirectToWebform(callbackUrl.toString(), {
    applicationID: applicationID ?? "",
    prodCode: prodCode ?? "",
    offerId: offer?.id ?? "",
    offerAmount: offer?.icorsAmount ?? "",
    icorsOfferType: offer?.icorsOfferType ?? "",
    custType,
    product,
    loginTimestamp: data.data?.loginTimestamp,
    resume,
    consentProduct: "EMICARD",
    consentId: "TnC-EMICARD",
    consentCategory: "TnC",
  });
};
